import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ComponentFactoryResolver,
  ViewEncapsulation
} from '@angular/core';
import {ConfirmationService, MessageService} from 'primeng/api';
import {TranslateService} from '@ngx-translate/core';
import {ReportTask} from "../../../../model/archive/report-task";
import {ReportTaskService} from "../../../../services/archive/report-task.service";
import {ArchiveFormAbsComponent} from "../../form/archive-form-abs.component";
import {RecapProfileService} from "../../../../services/archive/recap-profile.service";
import {ClearingUtils} from "../../../../utils/clearing-utils";
import {DatePipe} from "@angular/common";
import {CommonFieldService} from "../../../../services/common/common-field.service";
import {NotificationService} from "../../../../services/security/notification.service";
import {AppConfigService} from "../../../../services/app-config.service";
import {CcStorageService} from "../../../../services/common/cc-storage.service";
import {UserInfoStorageService} from "../../../../services/auth/user-info-storage.service";

@Component({
  selector: 'app-recap-form',
  templateUrl: './recap-form.component.html',
  styleUrls: ['../../form/archive-form-abs.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    MessageService,
    ConfirmationService,
    TranslateService,
    DatePipe,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RecapFormComponent extends ArchiveFormAbsComponent {

  constructor(cdref: ChangeDetectorRef,
              componentFactoryResolver: ComponentFactoryResolver,
              messageService: MessageService,
              confirmationService: ConfirmationService,
              recapProfileService: RecapProfileService,
              translateService: TranslateService,
              reportTaskService: ReportTaskService,
              notificationService: NotificationService,
              commonFieldService: CommonFieldService,
              appConfigService: AppConfigService,
              storageService: CcStorageService,
              userInfoStorageService: UserInfoStorageService,
              protected datePipe: DatePipe) {
    super(cdref, componentFactoryResolver, messageService, confirmationService, recapProfileService,
      translateService, reportTaskService, notificationService, commonFieldService, appConfigService, storageService,
      userInfoStorageService);
    super.origin = ReportTask.Origin.WEB_RECAP_FORM;
    super.transPartKey = 'recap-form';
    this.useProfiles = true;
  }

  protected setDateTo() {
    const today = this.datePipe.transform(ClearingUtils.getTodayDate(), 'dd/MM/yyyy');
    this.formRecord.customStartDate = today;
    this.formRecord.customEndDate = today;
  }
}
